var map = {
	"./vab-theme/layout/": 9048,
	"./vab-theme/layout/DefaultLayout": 1051,
	"./vab-theme/layout/DefaultLayout.vue": 1051,
	"./vab-theme/layout/PageLayout": 2519,
	"./vab-theme/layout/PageLayout.vue": 2519,
	"./vab-theme/layout/index": 9048,
	"./vab-theme/layout/index.js": 9048
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 3560;
module.exports = webpackAsyncContext;